module.exports = __webpack_public_path__ + "img/45_24.deaa2519.png";